/**
 * H23 sect dance (รำสำนัก): each sect holds it in its own sect-* map every 4 REAL hours for 15 minutes, the sects
 * staggered 30 min apart (8 sects x 30 min = one period). Members only. Pure schedule maths on epoch ms.
 */
import { SECT_TABLE } from './layouts/sects';

export const SECT_DANCE = {
  periodMs: 4 * 3_600_000,
  windowMs: 15 * 60_000,
  noticeMs: 10 * 60_000,
  staggerMs: 30 * 60_000,
  /** Training bonus for school neigong while the dance is on (fraction; the x3 cap still holds). */
  bonus: 0.5,
} as const;

export type SectDancePhase = 'open' | 'notice' | 'idle';
export interface SectDanceState {
  phase: SectDancePhase;
  /** ms until the window opens (idle/notice) or 0. */
  startsIn: number;
  /** ms until the window closes (open) or 0. */
  endsIn: number;
}

/** Stagger slot of a sect: its row in SECT_TABLE. -1 if unknown. */
export const sectSlot = (sect: string): number => SECT_TABLE.findIndex((r) => r.id === sect);

export function sectDanceState(sect: string, now: number): SectDanceState {
  const slot = Math.max(0, sectSlot(sect));
  const { periodMs, windowMs, noticeMs, staggerMs } = SECT_DANCE;
  const into = (((now - slot * staggerMs) % periodMs) + periodMs) % periodMs;
  if (into < windowMs) return { phase: 'open', startsIn: 0, endsIn: windowMs - into };
  const startsIn = periodMs - into;
  return { phase: startsIn <= noticeMs ? 'notice' : 'idle', startsIn, endsIn: 0 };
}
